import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralPageError from 'lumen/components/general/page/error';
import type HotelErrorController from 'lumen/controllers/hotel/error';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';

interface HotelErrorSignature {
  Args: {
    controller: HotelErrorController;
    model: unknown;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "error.title"))}}
  <GeneralPageError @errorCode={{@controller.reason}}>
    {{outlet}}
  </GeneralPageError>
</template> satisfies TOC<HotelErrorSignature>;
